export const cCurrencyMaskConfig = {
  align: "right",
  allowNegative: false,
  decimal: ".",
  precision: 2,
  prefix: "Q ",
  suffix: "",
  thousands: ","
};
